(ns app.rich-text
  (:require #?@(:clj [[jsonista.core :as jsonista]
                      [core.util.rich-text-html :as rt-html]])
            [clojure.string :as str]))

(defn parse-json [json-str]
  #?(:clj (jsonista/read-value json-str)
     :cljs (try
             (->> json-str
                  (.parse js/JSON)
                  js->clj)
             (catch js/SyntaxError _
               nil))))

#?(:clj
   (def html-to-text rt-html/html-to-text)

   :cljs
   (defn html-to-text [html-string]
     (when html-string
       (let [parser (js/DOMParser.)
             doc    (.parseFromString parser html-string "text/html")
             body   (.-body doc)]
         ;; Recursively walk through the child nodes, appending text and handling block elements
         (letfn [(node-to-text [node]
                   (cond
                     (= (.-nodeType node) js/Node.TEXT_NODE) (.-nodeValue node)
                     ;; Block elements like <p> should be separated by a space
                     (#{:P :H1 :H2 :H3 :H4 :H5 :H6 :UL :OL :BLOCKQUOTE} (keyword (.-tagName node)))
                     (str (reduce (fn [acc child]
                                    (str acc (node-to-text child)))
                                  "" (array-seq (.-childNodes node)))
                          " ")
                     ;; Inline elements
                     :else
                     (reduce (fn [acc child]
                               (str acc (node-to-text child)))
                             "" (array-seq (.-childNodes node)))))]

           (str/trim (node-to-text body)))))))

(defn html-to-text-if-string [html-string]
  (if (string? html-string) (html-to-text html-string) html-string))

(defn join-rich-text-content
  "Return concatenated strings representation from the rich-text document text blocks separated with a space character."
  [data]
  (or (try (some-> data
                   parse-json
                   (get "blocks")
                   (->> (keep #(get % "text"))
                        (str/join " ")))
           (catch #?(:clj  Exception
                     :cljs js/Error) _
             nil))
      (html-to-text data)))

#?(:clj
   (defn check-rt [data]
     (join-rich-text-content data)))

(defn html-paragraph [content]
  (str "<p>" content "</p>"))

(defn html-bold [content]
  (str "<strong>" content "</strong>"))

(defn empty-html-rich-text? [html]
  (if html
    #?(:clj
       (rt-html/empty-html-rich-text? html)

       :cljs
       (let [parser (js/DOMParser.)
             doc    (.parseFromString parser html "text/html")
             text   (str/trim (.-textContent (.-body doc)))]
         (str/blank? text)))
    true))

(defn empty-rich-text?
  "True when rich-text content (draft-js JSON or HTML) contains no text."
  [content]
  (or (nil? content)
      (str/blank? (join-rich-text-content content))))

(defn single-paragraph? [content]
  (let [plain-content (join-rich-text-content content)]
    (= content
       (html-paragraph plain-content))))
